import BottomSheetHeader from '@components/BottomSheetHeader';
import Button from '@components/Button';
import Column from '@components/Column';
import ImageUploader from '@components/ImageUploader';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import useInquiryCommentForm from './hooks/useInquiryCommentForm';

interface Params {
    inquiryId: string;
}

const InquiryCommentBottomSheet: ActivityComponentType<Params> = ({ params }:{params: Params}) => {
    const { t } = useTranslation('inquiry');
    const { inquiryId } = params;
    const {
        content, setContent, fileUrls, setFileUrls, handleCreateComment,
    } = useInquiryCommentForm(inquiryId);
    return (
        <BottomSheet>
            <BottomSheetHeader>
                {t('comment.title')}
            </BottomSheetHeader>
            <Container fullWidth spacing={20} >
                <Column fullWidth spacing={12}>
                    <Text size='lg' fontWeight='bold' color={colors.gray7} >
                        {t('comment.content')}
                    </Text>
                    <TextField as='textarea'
                        value={content}
                        onChange={(e) => setContent(e.target.value)}
                        rows={4}
                        placeholder={t('comment.contentPlaceholder')}
                        maxLength={200}
                        showLength />
                </Column>
                <Column fullWidth spacing={12}>
                    <Text size='lg' fontWeight='bold' color={colors.gray7}>
                        {t('comment.image')}
                    </Text>
                    <ImageUploader placeholder={t('comment.imagePlaceholder')}
                        maxLength={2}
                        value={fileUrls}
                        setValue={setFileUrls} />
                </Column>
                <CommentButton fullWidth
                    onClick={handleCreateComment} >
                    {t('comment.submit')}
                </CommentButton>
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    padding: 20px;
`;

const CommentButton = styled(Button)`
    margin-top: 24px;
`;

export default InquiryCommentBottomSheet;
